import React from 'react';
import { Helmet } from 'react-helmet';

import PageBanner from '../components/page-banner/page-banner.component';
import History from '../components/who-we-are/history/history';
import Impact from '../components/who-we-are/impact/impact';
import MissionStatement from '../components/who-we-are/mission-statement/mission-statement';
import Partners from '../components/who-we-are/partners/partners';
import TeamMembers from '../components/who-we-are/team-members/team-members';

const WhoWeArePage: React.FC = () => {
  return (
    <>
      <Helmet title="Who We Are" />
      <PageBanner
        pageTitle="Who We Are"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Who We Are"
      />
      <MissionStatement />
      <TeamMembers />
      <Partners />
      <Impact />
      <History />
    </>
  );
};

export default WhoWeArePage;
